// Directives
// 控制Input组件焦点
const vFocus = {
  update(el, { value }) {
    if (value) {
      (el.querySelector('input') || el).focus()
    }
  }
}

// 控制AutoComplete组件的回车及焦点
const vEnter = {
  bind(el, { value }) {
    let input = el.querySelector('input') || el
    input.setAttribute('autocomplete', 'off')
    input.addEventListener('keydown', e => {
      if (e.keyCode == 9) {
        document.body.click()
      }
    })
    input.addEventListener('keyup', e => {
      if (e.keyCode == 13 && value) {
        value()
      }
    })
  }
}

export {
  vFocus,
  vEnter
}



// WEBPACK FOOTER //
// ./src/commons/utils/Directives.js